module.exports = __webpack_public_path__ + "static/media/send-mes.c7252a79.svg";